export const ContentsId = {
  AutoCalculation: 'autoCalculation',
} as const;

export type ContentsId = (typeof ContentsId)[keyof typeof ContentsId];
